/* eslint-disable max-len */
import React from 'react';
import { Skeleton } from '../../ui/Skeleton';
import { useLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { InvokeAccountReadonlyPopupIfApplicable } from '../account/AccountReadonlyPopup';
import { LoadingNavigationView } from '../account/navigation/LoadingNavigationView';
import { NewNavigationView } from '../account/navigation/NewNavigationView';
import { PageProps } from '../common/Page';
import { Page2 } from '../common/Page2';
import { useReturnLocation } from '../common/ReturnLocation';
import { WorkspaceModel } from '../dashboard/Models';
import { NewWorkspaceScope, WorkspaceCrash } from './NewWorkspaceScope';

const RedirectIfAccountMismatch = () => {

    const account = useResolve(AccountModel);
    const workspace = useResolve(WorkspaceModel);

    if (workspace.accountId !== account.id) {
        location.href = `/${workspace.accountId}?redirect=${location.href}`;
    }

    return null;
};

const UseWorkspaceLocationScope = () => {
    const workspace = useResolve(WorkspaceModel);
    useLocationScope('workspace', workspace.id, workspace.label);
    return null;
};
const PageLoader = () =>
    <Page2 navigation={LoadingNavigationView}>
        <Page2.Header float>
            <Page2.Title>
                <Skeleton width="10" />
            </Page2.Title>
        </Page2.Header>
        <Page2.Content></Page2.Content>
    </Page2>;

export type NewWorkspacePageProps = Omit<PageProps, 'navigation'> & { entityId: string, children: React.ReactNode };

export const NewWorkspacePage = ({ entityId, children, ...props }: NewWorkspacePageProps) => {
    useReturnLocation(`/${entityId}`);
    // const param = params.param;
    return <NewWorkspaceScope entityId={entityId} crash={WorkspaceCrash} loader={PageLoader}>
        <UseWorkspaceLocationScope />
        <RedirectIfAccountMismatch />
        <InvokeAccountReadonlyPopupIfApplicable />
        <Page2 navigation={NewNavigationView}>
            {children}
        </Page2>
    </NewWorkspaceScope>;
};
